const BASE_API = process.env.MIX_ENDLESS_API_URL

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
	registerWithoutPasswordCompareModal({commit} ,payload){
		this.$axios.post(`/register-without-password`,payload.data).then(res => {
			if(res.data.success){
				window.location.href = `${payload.route}/comparison?source=register-without-password`
			}
		})
	},
	registerWithoutPassword({commit} ,payload){
		this.$axios.post(`/register-without-password`,payload.data).then(res => {
			if(res.data.success){
				location.reload()
			}
		})
	},
}

export default {namespaced:true,state,getters,mutations,actions}
